import { ChangeDetectorRef, Component, Input, ViewChild, output, inject } from '@angular/core';

import moment from 'moment-timezone';

import { trackByValue } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { getDefaultTimezone } from '@core/time-legacy';
import { TimePickerBridge, TimePickerComponent } from '@core/time-ui';
import type { TimeData } from '@core/time-ui';
import {
  ButtonComponent,
  DividerComponent,
  DropdownComponent,
  DropdownWidth,
  IconButtonComponent,
  IconComponent,
  DropdownItemComponent,
  DropdownHeaderComponent,
  NestedTemplateTriggerDirective,
} from '@core/user-interface-legacy';

export type SuggestedDate = {
  moment: moment.Moment;
  timezone?: string | null;
};

@Component({
  imports: [
    ButtonComponent,
    DividerComponent,
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    IconButtonComponent,
    IconComponent,
    NestedTemplateTriggerDirective,
    TimePickerComponent,
    TranslatePipe,
  ],
  selector: 'rt-mailbox-send-later-dropdown',
  templateUrl: './mailbox-send-later-dropdown.component.html',
  styleUrls: ['mailbox-send-later-dropdown.component.less'],
})
export class MailboxSendLaterDropdownComponent {
  private readonly cdRef = inject(ChangeDetectorRef);

  @Input() public timezoneText: string;
  @Input() public pickedDate: {
    sendAt: moment.Moment | null;
    sendAtTimezone: string | null;
    date?: string;
  };

  @Input() public lastSetSendLater: {
    date: string;
    moment: moment.Moment | null;
    timezone: string | null;
  } | null;

  @Input() public datesProposal: Array<{
    date: string;
    moment: moment.Moment | null;
    translation: string;
  }>;

  public pickedSuggestedDate = output<SuggestedDate>();
  public customDateRangeChanged = output<SuggestedDate>();

  @ViewChild(TimePickerComponent, { static: false }) public timePicker: TimePickerComponent;

  public DropdownWidth: typeof DropdownWidth = DropdownWidth;
  public defaultData: TimeData;
  public trackByValue = trackByValue;
  public isTimeValid: boolean = true;

  private timePickerBridge = new TimePickerBridge();

  constructor() {
    this.defaultData = this.timePickerBridge.convertMomentToComponentData(
      moment().add(1, 'h'),
      getDefaultTimezone(),
    );
  }

  public ngOnChanges(): void {
    const { sendAt, sendAtTimezone } = this.pickedDate;
    if (!sendAt) return;
    this.defaultData = this.timePickerBridge.convertMomentToComponentData(sendAt, sendAtTimezone);
  }

  public sendLater(): void {
    this.timePicker.applyChanges();
  }

  public onTimeValidationChanges(isTimeValid: boolean): void {
    this.isTimeValid = isTimeValid;
    this.cdRef.detectChanges();
  }

  public timePickerValueChanges(timeData: TimeData | null) {
    if (!timeData) return;
    const momentDate = this.timePickerBridge.convertComponentDataToMoment(timeData);
    this.customDateRangeChanged.emit({ moment: momentDate, timezone: timeData.zone });
  }
}
